const contact = {
  err_user_not_found: {
    message: 'Credited to is mandatory. Add it and try again.',
  },
  err_not_found: {
    message: 'Contact not found.',
  },
  err_city_not_found: {
    message: 'City is mandatory. Add a city to the location and try again.',
  },
  err_state_not_found: {
    message: 'State is mandatory. Add a state to the location and try again.',
  },
  err_country_not_found: {
    message:
      'Country is mandatory. Add a country to the location and try again.',
  },
  err_contact_belong_to_user: {
    message: 'You cannot edit your own contact.',
  },
  err_email_already_exist: {
    message: 'Email has already been taken',
  },
  url_duplicate: {
    message: 'Url has already been taken by the current contact',
  },
  err_url_already_exist: {
    message: 'Url has already been taken by the current contact',
  },
  err_contact_deleted: {
    message: 'This contact has been deleted already.',
  },
  err_linkedin_already_exist: {
    message: ' This LinkedIn URL is linked to a different candidate.',
  },
};

export default contact;
